<template>
    <div>
        <div class="position-absolute top-50 start-50 translate-middle w-75 d-flex justify-content-center text-center">
            <form class="col-lg-4" @submit.prevent @submit="login()">
                <div class="mb-3">
                    <input type="email" class="form-control" id="email" aria-describedby="emailHelp" placeholder="Mail"
                    v-model="login_form.email">
                </div>
                <div class="mb-3">
                    <input type="password" class="form-control" id="password" placeholder="Password"
                    v-model="login_form.password">
                </div>
                <!-- <div class="mb-3 form-check">
                    <input type="checkbox" class="form-check-input" id="exampleCheck1">
                    <label class="form-check-label" for="exampleCheck1">Check me out</label>
                </div> -->
                <button type="submit" class="btn-login w-100">登入</button>
                <button type="button" class="btn-login w-100 mt-2" @click="goRegistration()">創建帳號</button>
            </form>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Login',
    data(){
        return {
            login_form: {
                email: null,
                password: null,
            }
        };
    },
    methods:{
        login(){
            let that = this
            let error_str = ""
            for(var key in this.login_form){
                if(this.login_form[key] == null || this.login_form[key] == "" || this.login_form[key] == undefined){
                    error_str += `${key}, `
                }
            }
            if(error_str.length > 0){
                alert(`${error_str}is empty.`)
                return false
            }
            this.axios.post('/login', this.login_form).then(data=>{
                console.log(data.data)
                if(data.data.status == false){
                    alert("Email or Password Error!")
                    that.$store.commit("setLogin", false)
                    return false
                }
            }).catch(e=>{
                alert("Server under maintenance")
            })
            setTimeout(function(){
                that.$store.commit("setLogin", true)
                that.$router.push('/dashboard')
            }, 500)
        },
        goRegistration(){
            this.$router.push({'path': '/registration'})
        }
    }
}
</script>
<style>
.form-control{
    border-radius: unset !important;
    border: unset !important;
    border-bottom: 2px solid #7A7A7A !important;
    box-shadow: 0 4px 2px -2px rgba(0, 0, 0, 0.25);
}
.btn-login {
    background: #FFFFFF;
    border: 2px solid #565A97;
    box-sizing: border-box;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    border-radius: 30px;
}
</style>
